const en = {
  "pub.search": "Search dishes",
  "pub.searchPlaceholder": "Search the menu…",
  "pub.clearSearch": "Clear search",
  "pub.noResults": "No dishes match “{q}”",
  "pub.noResultsHint": "Try another word or clear the search.",
  "pub.unavailable": "Unavailable",
  "pub.unavailableLong": "This dish is currently unavailable.",
  "pub.close": "Close",
  "pub.emptyMenu": "The menu is being prepared",
  "pub.emptyMenuHint": "Please check back soon.",
  "pub.loadError": "We couldn't load the menu.",
  "pub.retry": "Try again",
  "pub.results": "Results: {n}",
  "pub.categories": "Menu categories",
  "pub.preview": "DRAFT PREVIEW — not visible to customers",
  "pub.previewAuth": "Sign in to the dashboard to preview drafts.",
  "pub.rights": "All rights reserved.",
  "pub.chooseMenu": "Choose a menu",
  "pub.chooseMenuHint": "Tap a menu to start browsing.",
  "pub.allMenus": "All menus",
  "nav.menus": "Menus",
  "cat.menu": "Menu",
  "cat.unassigned": "Not in any menu — hidden from guests",
  "mn.title": "Menus",
  "mn.subtitle": "The menus guests choose from on the first page.",
  "mn.add": "Add menu",
  "mn.newTitle": "New menu",
  "mn.editTitle": "Edit menu",
  "mn.slug": "Web address",
  "mn.slugHint": "Lowercase English letters, numbers and dashes. Changing it breaks old links to this menu.",
  "mn.slugInvalid": "Use lowercase English letters, numbers and dashes only.",
  "mn.image": "Menu image",
  "mn.logo": "Menu logo",
  "mn.visible": "Visible on the menu selection page",
  "mn.categories": "Categories: {n}",
  "mn.assign": "Assign categories",
  "mn.assignTitle": "Categories in “{name}”",
  "mn.assignHint": "Tick categories to move them (and their dishes) into this menu. To remove one, assign it to another menu.",
  "mn.inThisMenu": "In this menu",
  "mn.currentlyIn": "Currently in: {name}",
  "mn.unassigned": "No menu",
  "mn.preview": "Preview",
  "mn.previewLanding": "Preview selection page",
  "mn.publishHint": "Menu changes are saved as a draft. Click Publish at the top to make them live.",
  "mn.empty": "No menus yet.",
  "mn.deleteTitle": "Delete “{name}”?",
  "mn.deleteBody": "This menu has no categories and will be removed.",
  "mn.deleteBlocked": "This menu still has categories ({n}). Assign them to another menu first.",
  "an.menus": "Menu selections",
  "an.menusHint": "How often guests picked each menu on the selection page, and dish views inside it.",
  "an.menuViews": "dish views: {n}",
  "an.zone.menu_choice": "Menu selection cards",
  "an.zone.back": "Back to menus",
  "label.bestseller": "Bestseller",
  "label.new": "New",
  "label.spicy": "Spicy",
  "label.chef_pick": "Chef's pick",
  "diet.vegetarian": "Vegetarian",
  "diet.vegan": "Vegan",
  "diet.gluten_free": "Gluten-free",
  "diet.contains_nuts": "Contains nuts",
  "diet.seafood": "Seafood",
  "diet.dairy_free": "Dairy-free",

  "login.title": "Admin sign in",
  "login.subtitle": "Manage the Wok Town menu and website.",
  "login.email": "Email",
  "login.password": "Password",
  "login.submit": "Sign in",
  "login.signingIn": "Signing in…",
  "login.error": "Invalid email or password.",
  "login.locked": "Too many attempts. Try again in 15 minutes.",
  "login.back": "Back to menu",
  "nav.overview": "Overview",
  "nav.items": "Menu items",
  "nav.categories": "Categories",
  "nav.designer": "Website designer",
  "nav.qr": "QR code",
  "nav.menu": "Menu",
  "brand.dashboard": "Dashboard",
  "dash.color": "Dashboard colour",
  "dash.colorHint": "Changes only the dashboard, not the public menu.",
  "dash.custom": "Custom colour",
  "an.title": "Menu analytics",
  "an.subtitle": "How guests browse your public menu. Anonymous data only — no personal information is collected.",
  "an.export": "Export CSV",
  "an.error": "Could not load analytics.",
  "an.emptyTitle": "No visitor data for this period yet",
  "an.emptyHint": "Analytics appear as soon as guests open the public menu.",
  "an.overTime": "Visits over time",
  "an.r.today": "Today",
  "an.r.7d": "Last 7 days",
  "an.r.30d": "Last 30 days",
  "an.r.custom": "Custom range",
  "an.metric": "Metric",
  "an.current": "Current period",
  "an.previous": "Previous period",
  "an.change": "Change",
  "an.m.visits": "Menu visits",
  "an.m.unique_visitors": "Unique visitors",
  "an.m.sessions": "Browsing sessions",
  "an.m.dish_views": "Dish views",
  "an.m.avg_time_s": "Avg. active time",
  "an.m.returning": "Returning visitors",
  "an.m.qr_visits": "QR code visits",
  "an.dish": "Dish",
  "an.category": "Category",
  "an.views": "Views",
  "an.uniqueSessions": "Unique sessions",
  "an.avgView": "Avg. viewing time",
  "an.impressions": "Seen on menu (sessions)",
  "an.openRate": "Open rate",
  "an.quickCloses": "Quick closes",
  "an.clicksCol": "Tab clicks",
  "an.reach": "Sessions reached",
  "an.reachPct": "% of sessions",
  "an.attention": "Sections getting the most attention",
  "an.attentionHint": "Active time spent while each section was on screen.",
  "an.attentionCol": "Attention time (seconds)",
  "an.searchTerm": "Search term",
  "an.count": "Count",
  "an.noResults": "No results",
  "an.hour": "Hour",
  "an.date": "Date",
  "an.funnel": "Customer journey",
  "an.funnelHint": "Sessions at each step and how many stop browsing between steps.",
  "an.f.visit": "Menu visit",
  "an.f.browse": "Category browsing",
  "an.f.dish": "Dish view",
  "an.f.continue": "Continued browsing",
  "an.allSessions": "Starting point",
  "an.dropOff": "{n}% dropped off",
  "an.noPrev": "No previous data",
  "an.seconds": "{n}s",
  "an.topDish": "Most viewed dish",
  "an.topCategory": "Most popular category",
  "an.viewsN": "Views: {n}",
  "an.none": "No views yet",
  "an.popular": "Most popular dishes",
  "an.sort.views": "Most viewed",
  "an.sort.time": "Longest viewing",
  "an.sort.engagement": "Highest engagement",
  "an.viewsNote": "Views show attention, not sales — the menu has no ordering. Engagement = share of sessions that saw the dish and opened it.",
  "an.noData": "No data for this period.",
  "an.sessionsShort": "sessions",
  "an.mostViewed": "Most-clicked dishes",
  "an.popularCats": "Most popular categories",
  "an.popularCatsHint": "Dish views plus category tab clicks.",
  "an.engagement": "Longest viewing time by dish",
  "an.engagementHint": "Average active time the dish details stayed open.",
  "an.quick": "Opened and quickly closed",
  "an.quickHint": "Share of openings closed within 3 seconds.",
  "an.clicks": "Where visitors click",
  "an.zone.dish_card": "Dish cards",
  "an.zone.category_nav": "Category tabs",
  "an.zone.language": "Language switch",
  "an.zone.search": "Search",
  "an.zone.dish_details": "Dish details window",
  "an.zone.hero": "Hero banner",
  "an.zone.header": "Logo / header",
  "an.zone.announcement": "Announcement bar",
  "an.zone.footer": "Footer",
  "an.zone.other": "Other areas",
  "an.scroll": "Scroll depth & category reach",
  "an.scrollHint": "Share of sessions that scrolled at least this far, and that reached each section.",
  "an.languages": "Arabic vs English usage",
  "an.langDetail": "Dish views — English: {en}, Arabic: {ar}. Language switches: {s}.",
  "an.byHour": "Visits by hour",
  "an.byDay": "Visits by weekday",
  "an.searches": "Top search terms",
  "an.noResultSearches": "Searches with no results",
  "an.qr": "QR code traffic",
  "an.qrHint": "Visits that came from the dashboard's QR code (codes downloaded after this update).",
  "an.qrShare": "{n}% of all menu visits",
  "top.viewLive": "View live menu",
  "top.preview": "Preview draft",
  "top.logout": "Log out",
  "top.publish": "Publish",
  "status.unpublished": "Unpublished changes",
  "status.live": "Live menu is up to date",
  "status.lastPublished": "Last published {time}",
  "status.never": "Never published",
  "toast.published": "Published — changes are now live",
  "toast.publishFailed": "Publishing failed",
  "toast.saved": "Saved",
  "toast.saveFailed": "Could not save",
  "toast.deleted": "Deleted",
  "toast.duplicated": "Duplicated — the copy is hidden until you show it",
  "toast.loadFailed": "Could not load data",
  "toast.orderSaved": "Order saved",
  "ov.title": "Overview",
  "ov.subtitle": "Everything on your menu at a glance.",
  "ov.sampleNotice": "{n} SAMPLE dishes are still on your menu. Edit or delete them before sharing the menu with guests.",
  "ov.categories": "Categories",
  "ov.hiddenCats": "{n} hidden",
  "ov.items": "Menu items",
  "ov.visible": "Visible items",
  "ov.hidden": "Hidden items",
  "ov.unavailable": "Unavailable",
  "ov.translation": "Translation completeness",
  "ov.incomplete": "Need translations — dishes: {n}, categories: {c}.",
  "ov.fixTranslations": "Complete translations",
  "ov.publishing": "Publishing",
  "ov.publishHint": "Edits are saved as a draft. Customers only see them after you publish.",
  "ov.shortcuts": "Quick actions",
  "ov.addItem": "Add a dish",
  "ov.addCategory": "Add a category",
  "ov.customize": "Customize website",
  "ov.previewMenu": "Preview menu",
  "items.title": "Menu items",
  "items.subtitle": "Create, edit, reorder and hide dishes.",
  "items.add": "Add dish",
  "items.search": "Search dishes…",
  "items.allCategories": "All categories",
  "items.allVisibility": "Any visibility",
  "items.visible": "Visible",
  "items.hidden": "Hidden",
  "items.allAvailability": "Any availability",
  "items.available": "Available",
  "items.unavailable": "Unavailable",
  "items.allTranslations": "Any translation",
  "items.missingAny": "Missing translations",
  "items.missingAr": "Missing Arabic",
  "items.missingEn": "Missing English",
  "items.clearFilters": "Clear filters",
  "items.dragHint": "Drag rows by the handle or use the arrows to reorder.",
  "items.dragDisabled": "Clear search and filters to reorder dishes.",
  "items.noCategories": "Create a category first, then add dishes.",
  "items.empty": "No dishes match these filters.",
  "items.count": "Dishes: {n}",
  "items.emptyCat": "No dishes in this category yet.",
  "items.deleteTitle": "Delete this dish?",
  "items.deleteBody": "“{name}” will be permanently removed. To keep it but hide it from guests, use the Visible switch instead.",
  "items.moveUp": "Move up",
  "items.moveDown": "Move down",
  "items.edit": "Edit",
  "items.duplicate": "Duplicate",
  "items.delete": "Delete",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.save": "Save",
  "common.saving": "Saving…",
  "common.sample": "SAMPLE",
  "common.actions": "Actions",
  "editor.newTitle": "New dish",
  "editor.editTitle": "Edit dish",
  "editor.photo": "Photo",
  "editor.category": "Category",
  "editor.chooseCategory": "Choose a category",
  "editor.price": "Price",
  "editor.originalPrice": "Original price",
  "editor.promoPrice": "Promo price",
  "editor.visible": "Visible on menu",
  "editor.available": "Available",
  "editor.content": "Name & description (English and Arabic)",
  "editor.labels": "Labels",
  "editor.dietary": "Dietary tags",
  "val.category": "Choose a category.",
  "val.title": "Enter a title in at least one language.",
  "val.price": "Enter a valid price.",
  "val.number": "Must be a positive number.",
  "val.fix": "Please fix the highlighted fields.",
  "val.name": "Enter a name in at least one language.",
  "tr.complete": "EN + AR complete",
  "tr.missing_en": "English missing",
  "tr.missing_ar": "Arabic missing",
  "tr.nMissing": "{n} missing",
  "tr.allDone": "Complete",
  "tr.missingField": "Missing",
  "field.title": "Title",
  "field.description": "Description",
  "field.name": "Name",
  "up.type": "Use a JPG, PNG, WEBP or GIF image.",
  "up.size": "Images must be 8 MB or smaller.",
  "up.done": "Image uploaded",
  "up.failed": "Upload failed",
  "up.choose": "Click to upload an image",
  "up.replace": "Replace",
  "up.upload": "Upload",
  "up.remove": "Remove",
  "cat.title": "Categories",
  "cat.subtitle": "Organise the sections of your menu.",
  "cat.add": "Add category",
  "cat.newTitle": "New category",
  "cat.editTitle": "Edit category",
  "cat.image": "Category image (optional)",
  "cat.icon": "Icon (optional)",
  "cat.noIcon": "No icon",
  "cat.visible": "Visible on menu",
  "cat.hideTip": "Tip: hiding a category keeps it and its dishes, but removes them from the public menu.",
  "cat.items": "Dishes: {n}",
  "cat.empty": "No categories yet.",
  "cat.deleteTitle": "Delete “{name}”?",
  "cat.deleteHas": "This category contains dishes ({n}). What should happen to them?",
  "cat.deleteEmpty": "This category has no dishes and will be removed.",
  "cat.moveTo": "Move the dishes to another category",
  "cat.target": "Choose a category",
  "cat.deleteAll": "Delete the category and all its dishes ({n}) permanently",
  "des.title": "Website designer",
  "des.subtitle": "Every change updates the preview instantly. Save keeps a draft; Publish makes it live.",
  "des.unsaved": "Unsaved changes",
  "des.allSaved": "Draft saved",
  "des.discard": "Discard draft",
  "des.save": "Save draft",
  "des.publish": "Publish",
  "des.mobile": "Mobile",
  "des.tablet": "Tablet",
  "des.desktop": "Desktop",
  "des.openPreview": "Open full preview",
  "des.previewNote": "Preview shows your draft design and current menu edits. Customers still see the last published version.",
  "des.discardConfirm": "Discard all unpublished design changes and go back to the live design?",
  "des.discarded": "Draft discarded",
  "des.s.brand": "Logo & name",
  "des.s.colors": "Colours",
  "des.s.type": "Typography & shape",
  "des.s.header": "Announcement bar",
  "des.s.hero": "Hero banner",
  "des.s.nav": "Category navigation & search",
  "des.s.cards": "Menu cards & grid",
  "des.s.anim": "Animations",
  "des.s.footer": "Footer",
  "des.s.locale": "Language & currency",
  "des.s.seo": "SEO & sharing",
  "des.logo": "Logo",
  "des.name": "Restaurant name",
  "des.tagline": "Tagline",
  "des.showName": "Show restaurant name",
  "des.showTagline": "Show tagline",
  "des.logoSize": "Logo height",
  "des.primary": "Primary accent",
  "des.secondary": "Secondary accent",
  "des.bg": "Background",
  "des.surface": "Surface",
  "des.card": "Cards",
  "des.text": "Text",
  "des.muted": "Muted text",
  "des.price": "Price colour",
  "des.fontEn": "English font",
  "des.fontAr": "Arabic font",
  "des.radius": "Corner radius",
  "des.spacing": "Spacing",
  "des.enabled": "Show this section",
  "des.annText": "Announcement text",
  "des.heroImage": "Hero image",
  "des.headline": "Headline",
  "des.subtitleF": "Subtitle",
  "des.promo": "Promo message (optional)",
  "des.overlay": "Image darkening",
  "des.heightM": "Height on phones",
  "des.heightD": "Height on larger screens",
  "des.align": "Text alignment",
  "des.alignStart": "Start",
  "des.alignCenter": "Center",
  "des.alignEnd": "End",
  "des.sticky": "Sticky category bar",
  "des.showIcons": "Show category icons",
  "des.navStyle": "Tab style",
  "des.pill": "Pills",
  "des.underline": "Underline",
  "des.search": "Enable menu search",
  "des.cardStyle": "Card style",
  "des.elevated": "Elevated",
  "des.minimal": "Minimal",
  "des.horizontal": "List",
  "des.aspect": "Image aspect ratio",
  "des.colsM": "Columns on phones",
  "des.colsT": "Columns on tablets",
  "des.colsD": "Columns on desktops",
  "des.showDesc": "Show descriptions on cards",
  "des.showCatDesc": "Show category descriptions",
  "des.unavail": "Unavailable dishes",
  "des.unavailLabel": "Show with label",
  "des.unavailHide": "Hide automatically",
  "des.animEnabled": "Entrance animations",
  "des.animHover": "Hover effects",
  "des.footerText": "Footer text",
  "des.address": "Address",
  "des.hours": "Opening hours",
  "des.phone": "Phone",
  "des.instagram": "Instagram handle",
  "des.defaultLang": "Default menu language",
  "des.dashLangNote": "This is the language new guests see first. It does not change the dashboard language.",
  "des.currency": "Currency",
  "des.arabicDigits": "Use Arabic-Indic digits (٠١٢) in Arabic",
  "des.seoTitle": "Page title",
  "des.seoDesc": "Page description",
  "des.ogImage": "Social sharing image",
  "des.favicon": "Favicon",
  "qr.title": "QR code",
  "qr.subtitle": "Print this on tables so guests can open the menu instantly.",
  "qr.url": "Menu address",
  "qr.hint": "Use your deployed address or custom domain.",
  "qr.previewWarn": "This is a temporary preview address. After deploying, enter your live URL here and save it so printed QR codes keep working.",
  "qr.download": "Download PNG",
  "qr.saveUrl": "Save address",
};

const ar = {
  "pub.search": "ابحث عن طبق",
  "pub.searchPlaceholder": "ابحث في القائمة…",
  "pub.clearSearch": "مسح البحث",
  "pub.noResults": "لا توجد أطباق تطابق «{q}»",
  "pub.noResultsHint": "جرّب كلمة أخرى أو امسح البحث.",
  "pub.unavailable": "غير متوفر",
  "pub.unavailableLong": "هذا الطبق غير متوفر حاليًا.",
  "pub.close": "إغلاق",
  "pub.emptyMenu": "القائمة قيد التحضير",
  "pub.emptyMenuHint": "يرجى العودة قريبًا.",
  "pub.loadError": "تعذّر تحميل القائمة.",
  "pub.retry": "حاول مرة أخرى",
  "pub.results": "النتائج: {n}",
  "pub.categories": "أقسام القائمة",
  "pub.preview": "معاينة المسودة — غير ظاهرة للعملاء",
  "pub.previewAuth": "سجّل الدخول إلى لوحة التحكم لمعاينة المسودات.",
  "pub.rights": "جميع الحقوق محفوظة.",
  "pub.chooseMenu": "اختر القائمة",
  "pub.chooseMenuHint": "اضغط على قائمة لبدء التصفح.",
  "pub.allMenus": "كل القوائم",
  "nav.menus": "القوائم",
  "cat.menu": "القائمة",
  "cat.unassigned": "غير مرتبط بأي قائمة — مخفي عن الضيوف",
  "mn.title": "القوائم",
  "mn.subtitle": "القوائم التي يختار منها الضيوف في الصفحة الأولى.",
  "mn.add": "إضافة قائمة",
  "mn.newTitle": "قائمة جديدة",
  "mn.editTitle": "تعديل القائمة",
  "mn.slug": "عنوان الصفحة",
  "mn.slugHint": "أحرف إنجليزية صغيرة وأرقام وشرطات. تغييره يعطّل الروابط القديمة لهذه القائمة.",
  "mn.slugInvalid": "استخدم أحرفًا إنجليزية صغيرة وأرقامًا وشرطات فقط.",
  "mn.image": "صورة القائمة",
  "mn.logo": "شعار القائمة",
  "mn.visible": "ظاهرة في صفحة اختيار القائمة",
  "mn.categories": "الأقسام: {n}",
  "mn.assign": "تعيين الأقسام",
  "mn.assignTitle": "أقسام «{name}»",
  "mn.assignHint": "حدّد الأقسام لنقلها (مع أطباقها) إلى هذه القائمة. لإزالة قسم، عيّنه لقائمة أخرى.",
  "mn.inThisMenu": "في هذه القائمة",
  "mn.currentlyIn": "حاليًا في: {name}",
  "mn.unassigned": "بدون قائمة",
  "mn.preview": "معاينة",
  "mn.previewLanding": "معاينة صفحة الاختيار",
  "mn.publishHint": "تُحفظ تغييرات القوائم كمسودة. اضغط «نشر» في الأعلى لجعلها ظاهرة.",
  "mn.empty": "لا توجد قوائم بعد.",
  "mn.deleteTitle": "حذف «{name}»؟",
  "mn.deleteBody": "لا تحتوي هذه القائمة على أقسام وسيتم حذفها.",
  "mn.deleteBlocked": "لا تزال هذه القائمة تحتوي على أقسام ({n}). عيّنها لقائمة أخرى أولًا.",
  "an.menus": "اختيارات القوائم",
  "an.menusHint": "عدد مرات اختيار الضيوف لكل قائمة في صفحة الاختيار، ومشاهدات الأطباق داخلها.",
  "an.menuViews": "مشاهدات الأطباق: {n}",
  "an.zone.menu_choice": "بطاقات اختيار القائمة",
  "an.zone.back": "العودة إلى القوائم",
  "label.bestseller": "الأكثر مبيعًا",
  "label.new": "جديد",
  "label.spicy": "حار",
  "label.chef_pick": "اختيار الشيف",
  "diet.vegetarian": "نباتي",
  "diet.vegan": "نباتي صرف",
  "diet.gluten_free": "خالٍ من الغلوتين",
  "diet.contains_nuts": "يحتوي على مكسرات",
  "diet.seafood": "مأكولات بحرية",
  "diet.dairy_free": "خالٍ من الألبان",

  "login.title": "تسجيل دخول المسؤول",
  "login.subtitle": "أدِر قائمة وموقع ووك تاون.",
  "login.email": "البريد الإلكتروني",
  "login.password": "كلمة المرور",
  "login.submit": "تسجيل الدخول",
  "login.signingIn": "جارٍ تسجيل الدخول…",
  "login.error": "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
  "login.locked": "محاولات كثيرة. حاول بعد 15 دقيقة.",
  "login.back": "العودة إلى القائمة",
  "nav.overview": "نظرة عامة",
  "nav.items": "الأطباق",
  "nav.categories": "الأقسام",
  "nav.designer": "مصمم الموقع",
  "nav.qr": "رمز QR",
  "nav.menu": "القائمة",
  "brand.dashboard": "لوحة التحكم",
  "dash.color": "لون لوحة التحكم",
  "dash.colorHint": "يغيّر لوحة التحكم فقط، وليس القائمة العامة.",
  "dash.custom": "لون مخصص",
  "an.title": "تحليلات القائمة",
  "an.subtitle": "كيف يتصفّح الضيوف قائمتك. بيانات مجهولة فقط — لا يتم جمع أي معلومات شخصية.",
  "an.export": "تصدير CSV",
  "an.error": "تعذّر تحميل التحليلات.",
  "an.emptyTitle": "لا توجد بيانات زوار لهذه الفترة بعد",
  "an.emptyHint": "تظهر التحليلات بمجرد أن يفتح الضيوف القائمة العامة.",
  "an.overTime": "الزيارات بمرور الوقت",
  "an.r.today": "اليوم",
  "an.r.7d": "آخر 7 أيام",
  "an.r.30d": "آخر 30 يومًا",
  "an.r.custom": "فترة مخصصة",
  "an.metric": "المؤشر",
  "an.current": "الفترة الحالية",
  "an.previous": "الفترة السابقة",
  "an.change": "التغيّر",
  "an.m.visits": "زيارات القائمة",
  "an.m.unique_visitors": "الزوار الفريدون",
  "an.m.sessions": "جلسات التصفح",
  "an.m.dish_views": "مشاهدات الأطباق",
  "an.m.avg_time_s": "متوسط الوقت الفعلي",
  "an.m.returning": "الزوار العائدون",
  "an.m.qr_visits": "زيارات رمز QR",
  "an.dish": "الطبق",
  "an.category": "القسم",
  "an.views": "المشاهدات",
  "an.uniqueSessions": "جلسات فريدة",
  "an.avgView": "متوسط وقت المشاهدة",
  "an.impressions": "ظهر في القائمة (جلسات)",
  "an.openRate": "معدل الفتح",
  "an.quickCloses": "إغلاقات سريعة",
  "an.clicksCol": "نقرات التبويب",
  "an.reach": "الجلسات التي وصلت",
  "an.reachPct": "نسبة الجلسات",
  "an.attention": "الأقسام الأكثر اهتمامًا",
  "an.attentionHint": "الوقت الفعلي أثناء ظهور كل قسم على الشاشة.",
  "an.attentionCol": "وقت الاهتمام (ثوانٍ)",
  "an.searchTerm": "عبارة البحث",
  "an.count": "العدد",
  "an.noResults": "بدون نتائج",
  "an.hour": "الساعة",
  "an.date": "التاريخ",
  "an.funnel": "رحلة العميل",
  "an.funnelHint": "عدد الجلسات في كل مرحلة ونسبة من توقفوا بين المراحل.",
  "an.f.visit": "زيارة القائمة",
  "an.f.browse": "تصفح الأقسام",
  "an.f.dish": "مشاهدة طبق",
  "an.f.continue": "متابعة التصفح",
  "an.allSessions": "نقطة البداية",
  "an.dropOff": "توقف {n}%",
  "an.noPrev": "لا توجد بيانات سابقة",
  "an.seconds": "{n} ث",
  "an.topDish": "الطبق الأكثر مشاهدة",
  "an.topCategory": "القسم الأكثر شعبية",
  "an.viewsN": "المشاهدات: {n}",
  "an.none": "لا توجد مشاهدات بعد",
  "an.popular": "الأطباق الأكثر شعبية",
  "an.sort.views": "الأكثر مشاهدة",
  "an.sort.time": "الأطول مشاهدة",
  "an.sort.engagement": "الأعلى تفاعلًا",
  "an.viewsNote": "المشاهدات تعكس الاهتمام وليس المبيعات — لا يوجد نظام طلبات. التفاعل = نسبة الجلسات التي رأت الطبق وفتحته.",
  "an.noData": "لا توجد بيانات لهذه الفترة.",
  "an.sessionsShort": "جلسات",
  "an.mostViewed": "الأطباق الأكثر نقرًا",
  "an.popularCats": "الأقسام الأكثر شعبية",
  "an.popularCatsHint": "مشاهدات الأطباق مضافًا إليها نقرات تبويبات الأقسام.",
  "an.engagement": "أطول وقت مشاهدة حسب الطبق",
  "an.engagementHint": "متوسط الوقت الفعلي الذي بقيت فيه تفاصيل الطبق مفتوحة.",
  "an.quick": "فُتحت وأُغلقت بسرعة",
  "an.quickHint": "نسبة مرات الفتح التي أُغلقت خلال 3 ثوانٍ.",
  "an.clicks": "أين ينقر الزوار",
  "an.zone.dish_card": "بطاقات الأطباق",
  "an.zone.category_nav": "تبويبات الأقسام",
  "an.zone.language": "مبدّل اللغة",
  "an.zone.search": "البحث",
  "an.zone.dish_details": "نافذة تفاصيل الطبق",
  "an.zone.hero": "البانر الرئيسي",
  "an.zone.header": "الشعار / الترويسة",
  "an.zone.announcement": "شريط الإعلانات",
  "an.zone.footer": "التذييل",
  "an.zone.other": "مناطق أخرى",
  "an.scroll": "عمق التمرير والوصول للأقسام",
  "an.scrollHint": "نسبة الجلسات التي مرّرت إلى هذا الحد على الأقل، والتي وصلت إلى كل قسم.",
  "an.languages": "استخدام العربية مقابل الإنجليزية",
  "an.langDetail": "مشاهدات الأطباق — الإنجليزية: {en}، العربية: {ar}. تبديلات اللغة: {s}.",
  "an.byHour": "الزيارات حسب الساعة",
  "an.byDay": "الزيارات حسب اليوم",
  "an.searches": "أكثر عبارات البحث",
  "an.noResultSearches": "عمليات بحث بدون نتائج",
  "an.qr": "زيارات رمز QR",
  "an.qrHint": "الزيارات القادمة من رمز QR الخاص بلوحة التحكم (الرموز المنزّلة بعد هذا التحديث).",
  "an.qrShare": "{n}% من جميع زيارات القائمة",
  "top.viewLive": "عرض القائمة المنشورة",
  "top.preview": "معاينة المسودة",
  "top.logout": "تسجيل الخروج",
  "top.publish": "نشر",
  "status.unpublished": "تغييرات غير منشورة",
  "status.live": "القائمة المنشورة محدّثة",
  "status.lastPublished": "آخر نشر {time}",
  "status.never": "لم يتم النشر بعد",
  "toast.published": "تم النشر — التغييرات ظاهرة الآن",
  "toast.publishFailed": "فشل النشر",
  "toast.saved": "تم الحفظ",
  "toast.saveFailed": "تعذّر الحفظ",
  "toast.deleted": "تم الحذف",
  "toast.duplicated": "تم النسخ — النسخة مخفية حتى تقوم بإظهارها",
  "toast.loadFailed": "تعذّر تحميل البيانات",
  "toast.orderSaved": "تم حفظ الترتيب",
  "ov.title": "نظرة عامة",
  "ov.subtitle": "كل ما في قائمتك في لمحة واحدة.",
  "ov.sampleNotice": "لا تزال {n} أطباق تجريبية (SAMPLE) في قائمتك. عدّلها أو احذفها قبل مشاركة القائمة مع الضيوف.",
  "ov.categories": "الأقسام",
  "ov.hiddenCats": "{n} مخفي",
  "ov.items": "الأطباق",
  "ov.visible": "أطباق ظاهرة",
  "ov.hidden": "أطباق مخفية",
  "ov.unavailable": "غير متوفرة",
  "ov.translation": "اكتمال الترجمة",
  "ov.incomplete": "تحتاج إلى ترجمة — الأطباق: {n}، الأقسام: {c}.",
  "ov.fixTranslations": "إكمال الترجمات",
  "ov.publishing": "النشر",
  "ov.publishHint": "تُحفظ التعديلات كمسودة، ولا يراها العملاء إلا بعد النشر.",
  "ov.shortcuts": "إجراءات سريعة",
  "ov.addItem": "إضافة طبق",
  "ov.addCategory": "إضافة قسم",
  "ov.customize": "تخصيص الموقع",
  "ov.previewMenu": "معاينة القائمة",
  "items.title": "الأطباق",
  "items.subtitle": "أنشئ الأطباق وعدّلها ورتّبها وأخفِها.",
  "items.add": "إضافة طبق",
  "items.search": "ابحث في الأطباق…",
  "items.allCategories": "كل الأقسام",
  "items.allVisibility": "أي ظهور",
  "items.visible": "ظاهر",
  "items.hidden": "مخفي",
  "items.allAvailability": "أي توفر",
  "items.available": "متوفر",
  "items.unavailable": "غير متوفر",
  "items.allTranslations": "أي ترجمة",
  "items.missingAny": "ترجمات ناقصة",
  "items.missingAr": "العربية ناقصة",
  "items.missingEn": "الإنجليزية ناقصة",
  "items.clearFilters": "مسح الفلاتر",
  "items.dragHint": "اسحب الصفوف من المقبض أو استخدم الأسهم لإعادة الترتيب.",
  "items.dragDisabled": "امسح البحث والفلاتر لإعادة ترتيب الأطباق.",
  "items.noCategories": "أنشئ قسمًا أولًا ثم أضف الأطباق.",
  "items.empty": "لا توجد أطباق تطابق هذه الفلاتر.",
  "items.count": "الأطباق: {n}",
  "items.emptyCat": "لا توجد أطباق في هذا القسم بعد.",
  "items.deleteTitle": "حذف هذا الطبق؟",
  "items.deleteBody": "سيتم حذف «{name}» نهائيًا. للاحتفاظ به مع إخفائه عن الضيوف، استخدم مفتاح الظهور بدلًا من ذلك.",
  "items.moveUp": "تحريك للأعلى",
  "items.moveDown": "تحريك للأسفل",
  "items.edit": "تعديل",
  "items.duplicate": "نسخ",
  "items.delete": "حذف",
  "common.cancel": "إلغاء",
  "common.delete": "حذف",
  "common.save": "حفظ",
  "common.saving": "جارٍ الحفظ…",
  "common.sample": "تجريبي",
  "common.actions": "إجراءات",
  "editor.newTitle": "طبق جديد",
  "editor.editTitle": "تعديل الطبق",
  "editor.photo": "الصورة",
  "editor.category": "القسم",
  "editor.chooseCategory": "اختر قسمًا",
  "editor.price": "السعر",
  "editor.originalPrice": "السعر الأصلي",
  "editor.promoPrice": "سعر العرض",
  "editor.visible": "ظاهر في القائمة",
  "editor.available": "متوفر",
  "editor.content": "الاسم والوصف (بالإنجليزية والعربية)",
  "editor.labels": "الشارات",
  "editor.dietary": "الوسوم الغذائية",
  "val.category": "اختر قسمًا.",
  "val.title": "أدخل اسمًا بلغة واحدة على الأقل.",
  "val.price": "أدخل سعرًا صحيحًا.",
  "val.number": "يجب أن يكون رقمًا موجبًا.",
  "val.fix": "يرجى تصحيح الحقول المحددة.",
  "val.name": "أدخل اسمًا بلغة واحدة على الأقل.",
  "tr.complete": "الإنجليزية والعربية مكتملة",
  "tr.missing_en": "الإنجليزية ناقصة",
  "tr.missing_ar": "العربية ناقصة",
  "tr.nMissing": "{n} ناقص",
  "tr.allDone": "مكتمل",
  "tr.missingField": "ناقص",
  "field.title": "الاسم",
  "field.description": "الوصف",
  "field.name": "الاسم",
  "up.type": "استخدم صورة بصيغة JPG أو PNG أو WEBP أو GIF.",
  "up.size": "يجب ألا يتجاوز حجم الصورة 8 ميغابايت.",
  "up.done": "تم رفع الصورة",
  "up.failed": "فشل الرفع",
  "up.choose": "انقر لرفع صورة",
  "up.replace": "استبدال",
  "up.upload": "رفع",
  "up.remove": "إزالة",
  "cat.title": "الأقسام",
  "cat.subtitle": "نظّم أقسام قائمتك.",
  "cat.add": "إضافة قسم",
  "cat.newTitle": "قسم جديد",
  "cat.editTitle": "تعديل القسم",
  "cat.image": "صورة القسم (اختياري)",
  "cat.icon": "أيقونة (اختياري)",
  "cat.noIcon": "بدون أيقونة",
  "cat.visible": "ظاهر في القائمة",
  "cat.hideTip": "نصيحة: إخفاء القسم يحتفظ به وبأطباقه لكنه يزيلها من القائمة العامة.",
  "cat.items": "الأطباق: {n}",
  "cat.empty": "لا توجد أقسام بعد.",
  "cat.deleteTitle": "حذف «{name}»؟",
  "cat.deleteHas": "يحتوي هذا القسم على أطباق ({n}). ماذا تريد أن تفعل بها؟",
  "cat.deleteEmpty": "لا يحتوي هذا القسم على أطباق وسيتم حذفه.",
  "cat.moveTo": "نقل الأطباق إلى قسم آخر",
  "cat.target": "اختر قسمًا",
  "cat.deleteAll": "حذف القسم وجميع أطباقه ({n}) نهائيًا",
  "des.title": "مصمم الموقع",
  "des.subtitle": "كل تغيير يظهر فورًا في المعاينة. الحفظ يحتفظ بمسودة، والنشر يجعلها ظاهرة للعملاء.",
  "des.unsaved": "تغييرات غير محفوظة",
  "des.allSaved": "تم حفظ المسودة",
  "des.discard": "تجاهل المسودة",
  "des.save": "حفظ المسودة",
  "des.publish": "نشر",
  "des.mobile": "جوال",
  "des.tablet": "جهاز لوحي",
  "des.desktop": "سطح المكتب",
  "des.openPreview": "فتح المعاينة الكاملة",
  "des.previewNote": "تعرض المعاينة تصميم المسودة وتعديلات القائمة الحالية. يرى العملاء آخر نسخة منشورة فقط.",
  "des.discardConfirm": "تجاهل جميع تغييرات التصميم غير المنشورة والعودة إلى التصميم المنشور؟",
  "des.discarded": "تم تجاهل المسودة",
  "des.s.brand": "الشعار والاسم",
  "des.s.colors": "الألوان",
  "des.s.type": "الخطوط والشكل",
  "des.s.header": "شريط الإعلانات",
  "des.s.hero": "البانر الرئيسي",
  "des.s.nav": "تنقل الأقسام والبحث",
  "des.s.cards": "بطاقات القائمة والشبكة",
  "des.s.anim": "الحركات",
  "des.s.footer": "التذييل",
  "des.s.locale": "اللغة والعملة",
  "des.s.seo": "تحسين البحث والمشاركة",
  "des.logo": "الشعار",
  "des.name": "اسم المطعم",
  "des.tagline": "الشعار النصي",
  "des.showName": "إظهار اسم المطعم",
  "des.showTagline": "إظهار الشعار النصي",
  "des.logoSize": "ارتفاع الشعار",
  "des.primary": "اللون الأساسي",
  "des.secondary": "اللون الثانوي",
  "des.bg": "الخلفية",
  "des.surface": "السطح",
  "des.card": "البطاقات",
  "des.text": "النص",
  "des.muted": "النص الخافت",
  "des.price": "لون السعر",
  "des.fontEn": "الخط الإنجليزي",
  "des.fontAr": "الخط العربي",
  "des.radius": "استدارة الزوايا",
  "des.spacing": "المسافات",
  "des.enabled": "إظهار هذا القسم",
  "des.annText": "نص الإعلان",
  "des.heroImage": "صورة البانر",
  "des.headline": "العنوان الرئيسي",
  "des.subtitleF": "العنوان الفرعي",
  "des.promo": "رسالة ترويجية (اختياري)",
  "des.overlay": "تعتيم الصورة",
  "des.heightM": "الارتفاع على الجوال",
  "des.heightD": "الارتفاع على الشاشات الكبيرة",
  "des.align": "محاذاة النص",
  "des.alignStart": "البداية",
  "des.alignCenter": "الوسط",
  "des.alignEnd": "النهاية",
  "des.sticky": "شريط أقسام ثابت",
  "des.showIcons": "إظهار أيقونات الأقسام",
  "des.navStyle": "نمط التبويبات",
  "des.pill": "كبسولات",
  "des.underline": "خط سفلي",
  "des.search": "تفعيل البحث في القائمة",
  "des.cardStyle": "نمط البطاقة",
  "des.elevated": "بارز",
  "des.minimal": "بسيط",
  "des.horizontal": "قائمة",
  "des.aspect": "نسبة أبعاد الصورة",
  "des.colsM": "الأعمدة على الجوال",
  "des.colsT": "الأعمدة على الأجهزة اللوحية",
  "des.colsD": "الأعمدة على سطح المكتب",
  "des.showDesc": "إظهار الوصف على البطاقات",
  "des.showCatDesc": "إظهار وصف الأقسام",
  "des.unavail": "الأطباق غير المتوفرة",
  "des.unavailLabel": "إظهار مع شارة",
  "des.unavailHide": "إخفاء تلقائي",
  "des.animEnabled": "حركات الظهور",
  "des.animHover": "تأثيرات التمرير",
  "des.footerText": "نص التذييل",
  "des.address": "العنوان",
  "des.hours": "ساعات العمل",
  "des.phone": "الهاتف",
  "des.instagram": "حساب إنستغرام",
  "des.defaultLang": "لغة القائمة الافتراضية",
  "des.dashLangNote": "هذه هي اللغة التي يراها الضيوف الجدد أولًا، ولا تغيّر لغة لوحة التحكم.",
  "des.currency": "العملة",
  "des.arabicDigits": "استخدام الأرقام العربية الهندية (٠١٢) في العربية",
  "des.seoTitle": "عنوان الصفحة",
  "des.seoDesc": "وصف الصفحة",
  "des.ogImage": "صورة المشاركة الاجتماعية",
  "des.favicon": "أيقونة الموقع",
  "qr.title": "رمز QR",
  "qr.subtitle": "اطبعه على الطاولات ليفتح الضيوف القائمة فورًا.",
  "qr.url": "عنوان القائمة",
  "qr.hint": "استخدم عنوان الموقع المنشور أو نطاقك الخاص.",
  "qr.previewWarn": "هذا عنوان معاينة مؤقت. بعد النشر، أدخل عنوانك الفعلي هنا واحفظه حتى تستمر رموز QR المطبوعة بالعمل.",
  "qr.download": "تنزيل PNG",
  "qr.saveUrl": "حفظ العنوان",
};

export const STRINGS = { en, ar };

const cache = {};
export function makeT(lang) {
  if (cache[lang]) return cache[lang];
  const table = STRINGS[lang] || en;
  cache[lang] = (key, vars) => {
    const s = table[key] ?? en[key] ?? key;
    return vars ? s.replace(/\{(\w+)\}/g, (_, v) => (vars[v] ?? "")) : s;
  };
  return cache[lang];
}
